export default "__VITE_ASSET__Bkz5AiJw__"